export default __webpack_public_path__ + "static/media/SolarPathSvg.96f59ff2.svg";